import React from 'react';
import { Table } from 'reactstrap';
import './style/table.css';
import DragScroll from '../dragscroll';

export default class Tabela extends React.Component {
  static defaultProps = {
    styleDiv: null,
    overflow: null,
    listagemContainer: true,
  };

  render() {
    let { style, responsive, drag, styleDiv, overflow, stickyHeader, hover = true, listagemContainer, ...other } = this.props;

    // Lógica para listagemContainer: remove sticky header e adiciona overflow-auto
    const finalStickyHeader = listagemContainer ? false : stickyHeader;
    const finalStyleDiv = listagemContainer 
      ? { ...styleDiv, overflow: 'auto' }
      : styleDiv;

    let classNames = responsive ? 'table-responsive' : '';
    classNames += finalStickyHeader ? ' sticky-header' : '';

    return responsive ? (
      <div style={finalStyleDiv ? finalStyleDiv : { paddingBottom: 15 }} className={classNames}>
        {drag ? (
          <DragScroll overflow={overflow} height="auto" width="100%">
            <Table style={{ overflow: 'visible', ...style }} {...other} hover={hover}>
              {this.props.children}
            </Table>
          </DragScroll>
        ) : (
          <Table style={{ overflow: 'visible', ...style }} {...other} hover={hover}>
            {this.props.children}
          </Table>
        )}
      </div>
    ) : (
      <div style={finalStyleDiv ? finalStyleDiv : { paddingBottom: 15 }}>
        <Table style={{ overflow: 'visible', width: '99%', ...style }} {...other} hover={hover}>
          {this.props.children}
        </Table>
      </div>
    );
  }
}
